import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// UserManagment
import Report from '@/views/Report/JobRequest/index'
import OperatingStatementAnalysis from "@/views/Dashboard/OperatingStatementAnalysis/index"

const reportRouter = [
  {
    path: "/Report",
    element: <SandBox />,
    children: [
      {
        path: "JobRequest",
        element: docLazyFn(<Report />),
      },
      {
        path: "OperatingStatementAnalysis",
        element: docLazyFn(<OperatingStatementAnalysis />),
      },
    ],
  }
];

export default reportRouter;
